import React from 'react';
import { NavLink } from 'react-router-dom';

const Sidebar = ({ onLogout, children }) => {
  return (
    <div className="d-flex">
      {/* Sidebar */}
      <nav className="bg-dark text-white vh-100 p-3" style={{ width: '250px' }}>
        <h3 className="text-center mb-4">ERP Dashboard</h3>
        <ul className="nav flex-column">
          <li className="nav-item mb-2">
            <NavLink 
              to="/suppliers" 
              className={({ isActive }) => 
                "nav-link text-white " + (isActive ? "active bg-primary rounded" : "")
              }>
              Suppliers
            </NavLink>
          </li>
          <li className="nav-item mb-2">
            <NavLink 
              to="/offline-crud" 
              className={({ isActive }) => 
                "nav-link text-white " + (isActive ? "active bg-primary rounded" : "")
              }>
              Offline CRUD
            </NavLink>
          </li>
          <li className="nav-item mb-2">
            <NavLink 
              to="/register" 
              className={({ isActive }) => 
                "nav-link text-white " + (isActive ? "active bg-primary rounded" : "")
              }>
              Register
            </NavLink>
          </li>
          <li className="nav-item mt-auto">
            <button className="btn btn-danger w-100" onClick={onLogout}>
              Logout
            </button>
          </li>
        </ul>
      </nav>

      {/* Content Area */}
      <div className="flex-grow-1 p-3" style={{ minHeight: '100vh' }}>
        {children}
      </div>
    </div>
  );
};

export default Sidebar;
